import React, { useState } from "react";
import { IoSpeedometer } from "react-icons/io5";
import { RiPaintBrushFill } from "react-icons/ri";
import { FaStoreAlt } from "react-icons/fa";
import { formatNumberComma, formatNumber } from "../utils/numberUtils";

const VehicleGrid = ({ data = [], type = "", condition = true }) => {
  const defaultCarImage = `https://finditzstg.wpengine.com/wp-content/uploads/2024/07/car-placeholder.jpg`;
  const [imageLoading, setImageLoading] = useState(true);

  const handleImageLoaded = () => {
    setImageLoading(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const options = { year: '2-digit', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-US', options);
  };

  return (
    <div className='card-grid'>
      {data.length > 0
        ? data.map((car, index) => {
            let imageSrc =
              car?.featured_image_url || car?.media?.photo_links?.[0] || "";

            return (
              <div key={index} className='car-card'>
                <a
                    href={`/details/?detail_id=${car.id}${
                      car.id.length > 5 && type !== "" ? `&type=${type}` : ""
                    }`}
                  >
                  <div>
                    <img
                      src={imageSrc}
                      alt='Car'
                      className={`car-image ${imageLoading ? "hidden" : ""}`}
                      onLoad={handleImageLoaded}
                      onError={(e) => {
                        e.target.src = defaultCarImage;
                        setImageLoading(false);
                      }}
                    />
                  </div>
                </a>
                <a
                  href={`/details/?detail_id=${car.id}${
                      car.id.length > 5 && type !== "" ? `&type=${type}` : ""
                    }`}
                >
                <div className='content'>
                  <h3>
                      {condition && (
                        <>
                          {(
                            car?.hp_listing_v_details_condition?.[0]?.name ||
                            (car?.inventory_type?.includes("used")
                              ? "USED"
                              : "NEW")
                          )?.toUpperCase()}
                        </>
                      )}{" "}
                      {car?.meta?.hp_v_essentials_year || car?.build?.year}{" "}
                      {car?.meta?.hp_v_essentials_make || car?.build?.make}{" "}
                      {car?.meta?.hp_v_essentials_make_model ||
                        car?.build?.model}
                    <span
  className="original-name"
  dangerouslySetInnerHTML={{
    __html: `(${car?.title?.rendered || car?.heading})`,
  }}
></span>
                  </h3>
                  {car?.dealer?.name && (
                    <span className='car-attr flex'>
                      <FaStoreAlt />
                      <a href={car?.vdp_url}>{car?.dealer?.name}</a>
                    </span>
                  )}
                  {car?.meta?.hp_location && (
                    <div className='car-attr'>
                      <span>{car?.meta?.hp_location}</span>
                    </div>
                  )}
                  <div className='car-attr'>
                    {car?.meta?.hp_v_details_mileage ? (
                      <span>
                        <IoSpeedometer />{" "}
                        {formatNumberComma(car.meta.hp_v_details_mileage)} miles
                      </span>
                    ) : car?.miles ? (
                      <span>
                        <IoSpeedometer /> {formatNumberComma(car.miles)} miles
                      </span>
                    ) : null}
                    {car?.hp_listing_v_details_exterior_co?.[0]?.name ? (
                      <span>
                        <RiPaintBrushFill />{" "}
                        {car?.hp_listing_v_details_exterior_co?.[0]?.name}
                      </span>
                    ) : car?.exterior_color ? (
                      <span>
                        <RiPaintBrushFill /> {car?.exterior_color}
                      </span>
                    ) : null}
                  </div>
                  {car?.meta?.hp_price ? (
                    <span className='car-attr price-tag'>
                      ${formatNumber(car?.meta?.hp_price)}
                    </span>
                  ) : car?.price ? (
                    <span className='car-attr price-tag'>
                      ${formatNumber(car?.price)}
                    </span>
                  ) : null}
                  <span className="listed-on">
                    <b>Listed on:</b> {car?.date ? formatDate(car?.date) : formatDate(car?.first_seen_at_date)}
                  </span>
                </div>
                </a>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default VehicleGrid;
